module.exports = __webpack_public_path__ + "img/single-stat-light.03af3999.svg";